import { Component, inject } from "@angular/core";
import { SigtChargementEnCoursService } from "./sigt-chargement-en-cours.service";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'sigt-chargement-en-cours',
    templateUrl: './sigt-chargement-en-cours.component.html',
    styleUrls: ['./sigt-chargement-en-cours.component.scss'],
    imports: [
        CommonModule
    ]
})
export class SigtChargementEnCoursComponent {
  #chargementEnCoursService = inject(SigtChargementEnCoursService);

  estVisible = this.#chargementEnCoursService.estVisible;
}
